import { Link } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import '../css/booking.scss';
import Box from '@mui/material/Box';

const Booking = () => (//) = ({lightId, lightName, lightComment} : Props) => (
  <Box>
    <Box className="booking-mobile"
      sx={(theme) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#6F6F6F' : '#EFEFEF',
        color: '#CA8E4C',
        '& a': {
          color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#000000',
        },
      })}>
      <Link to="contact">
        <h3>Service de taxi à Charleroi</h3>
        <p>Transport : aéroports et gares en Belgique</p>
        <p>Disponible 24h/24 et 7j/7 en cas d'urgence</p>
        <img id="scheduling-17983227" src="images/rdv.png" alt="Bouton réserver maintenant" />
      </Link>
    </Box>

    <Box className="booking">
      <Box>
        <Carousel
          infiniteLoop={true}
          showThumbs={false}
          autoPlay={true}
          emulateTouch={true}
          swipeable={true}
          useKeyboardArrows={true}
          showStatus={false}
        // renderIndicator={renderIndicator}
        >
          <div id="koffi-transport" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  Koffi Transports : Votre service de transport dans la région de Charleroi <br />
                  <img id="scheduling-17983227" src="images/rdv.png" alt="Bouton réserver maintenant" />
                  {/* <p className="legend">Legend 1</p> */}
                </div>
              </Link>
            </div>
          </div>
          <div id="transport-aeroport" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  Transport vers les aéroports et les gares de Belgique et des pays aux alentours<br />
                  <img id="scheduling-17983227" src="images/rdv.png" alt="Bouton réserver maintenant" />
                  {/* <p className="legend">Legend 2</p> */}
                </div>
              </Link>
            </div>
          </div>
          <div id="disponible-24h24-7j7" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  Disponible 24h/24 et 7j/7 en cas d'urgence <br />
                  <img id="scheduling-17983227" src="images/rdv.png" alt="Bouton réserver maintenant" />
                  {/* <p className="legend">Legend 3</p> */}
                </div>
              </Link>
            </div>
          </div>
        </Carousel>
      </Box>
    </Box>

  </Box>
  //onclick="openScheduling(17983227)"
);

export default Booking;
